// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../assets/background.png");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
exports.push([module.id, ".background[data-v-d227be8a]{background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ");background-size:100% 100%}.pageTitleFixed[data-v-d227be8a]{position:fixed;top:0;left:0;width:100%;z-index:1;background-color:#fff}.van-nav-bar[data-v-d227be8a]{background-color:transparent}[class*=van-hairline][data-v-d227be8a]:after{border:none}[data-v-d227be8a]:export{green:#3f9775;white:#fff}", ""]);
// Exports
module.exports = exports;
